import { render, staticRenderFns } from "./CultureStoryDetail.vue?vue&type=template&id=2f81cc0a"
import script from "./CultureStoryDetail.vue?vue&type=script&lang=js"
export * from "./CultureStoryDetail.vue?vue&type=script&lang=js"
import style0 from "./CultureStoryDetail.vue?vue&type=style&index=0&id=2f81cc0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports